/**
 * Minimal WKT-parser för PostGIS-output av MULTILINESTRING.
 *
 * Backend skickar geometryWkt som strängen
 *   "MULTILINESTRING((lon lat, lon lat, ...), (lon lat, ...))"
 *
 * Schemat (V202604270003 + V202605040001) tvingar typen MULTILINESTRING
 * + SRID 4326, så vi behöver bara klara denna ena form. Mer generell
 * WKT-parsning är onödig och ger angreppsyta.
 *
 * Returnerar lista med polylines, där varje polyline är lista med
 * [lng, lat]-koordinatpar (GeoJSON-konvention). Tom lista vid parse-fel.
 */
export function parseMultiLineStringWkt(wkt: string): Array<Array<[number, number]>> {
  const trimmed = wkt.trim();
  const prefix = 'MULTILINESTRING';
  if (!trimmed.toUpperCase().startsWith(prefix)) return [];

  const body = trimmed.substring(prefix.length).trim();
  if (!body.startsWith('(') || !body.endsWith(')')) return [];
  const inner = body.substring(1, body.length - 1).trim();

  // Splitta på "), (" — varje del är en LineString.
  const segments = inner.split(/\)\s*,\s*\(/);
  const result: Array<Array<[number, number]>> = [];
  for (const seg of segments) {
    const cleaned = seg.replace(/^\(/, '').replace(/\)$/, '').trim();
    const pointStrings = cleaned.split(',');
    const points: Array<[number, number]> = [];
    for (const ps of pointStrings) {
      const nums = ps.trim().split(/\s+/);
      if (nums.length < 2) return [];
      const lng = Number(nums[0]);
      const lat = Number(nums[1]);
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return [];
      if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return [];
      points.push([lng, lat]);
    }
    if (points.length < 2) return [];
    result.push(points);
  }
  return result;
}
